"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const js_cookie_1 = __importDefault(require("js-cookie"));
const common_buoy_button_1 = require("@buoyhealth/common.buoy-button");
const styled_components_1 = __importStar(require("styled-components"));
const styles_1 = require("@mui/material/styles");
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const common_buoy_layout_1 = require("@buoyhealth/common.buoy-layout");
const cookies_1 = require("../../common/cookies");
const constants_1 = require("./constants");
const UserFeedback_1 = __importDefault(require("../UserFeedback"));
const snowplowConfig_1 = require("../../common/snowplowConfig");
const withSnowplowTracking_1 = require("../withSnowplowTracking");
const getUserFeedbackSubmittedCookie = () => js_cookie_1.default.get(cookies_1.COOKIE_USER_FEEDBACK_SUBMITTED_DATE);
const getUserFeedbackDismissedCookie = () => js_cookie_1.default.get(cookies_1.COOKIE_USER_FEEDBACK_DISMISSED_DATE);
const getUserFeedbackLastSubmittedQuestionCookie = () => js_cookie_1.default.get(cookies_1.COOKIE_USER_FEEDBACK_LAST_SUBMITTED_QUESTION_INDEX);
const ButtonWrapper = (0, styled_components_1.default)(common_buoy_layout_1.CenteredColumnContainer) `
  display: flex;
  justify-content: flex-end;
  opacity: ${(props) => props.$opacity};
  transition: 0.2s ease-in-out all;

  ${(props) => props.fullWidth && {
    margin: 0,
    padding: 0,
    "max-width": "none",
}}
`;
const buttonStyles = (0, styled_components_1.css) `
  background-color: ${(props) => props.theme.palette.blue[0]};
  padding: 8px 16px;
  border-radius: 0;

  &:hover {
    background-color: ${(props) => props.theme.palette.blue[0]};
  }

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "width",
    values: { xs: "100%", md: "auto" },
})}

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "padding",
    values: { xs: "16px", md: "8px 16px" },
})}
`;
const UserFeedbackModal = ({ baseRoute, surveyMonkeyLink, userFeedbackCookieExpiration = constants_1.USER_FEEDBACK_COOKIE_EXPIRATION, userFeedbackPromptTimeout = constants_1.USER_FEEDBACK_PROMPT_TIMEOUT, }) => {
    const [isUserFeedbackVisible, setIsUserFeedbackVisible] = (0, react_1.useState)(false);
    const [isFeedbackButtonInFooterVisible, setIsFeedbackButtonInFooterVisible] = (0, react_1.useState)(false);
    const r = (0, common_buoy_theme_1.useResponsive)();
    const theme = (0, styles_1.useTheme)();
    const setUserAnsweredQuestionCookie = (questionIndex) => {
        js_cookie_1.default.set(cookies_1.COOKIE_USER_FEEDBACK_LAST_SUBMITTED_QUESTION_INDEX, questionIndex.toString(), {
            expires: constants_1.USER_FEEDBACK_COOKIE_EXPIRATION,
            path: `${baseRoute}/`,
        });
    };
    const setUserFeedbackCookie = (surveyCompleted) => {
        js_cookie_1.default.set(surveyCompleted
            ? cookies_1.COOKIE_USER_FEEDBACK_SUBMITTED_DATE
            : cookies_1.COOKIE_USER_FEEDBACK_DISMISSED_DATE, new Date(), {
            expires: userFeedbackCookieExpiration,
            path: `${baseRoute}/`,
        });
    };
    (0, react_1.useEffect)(() => {
        const surveyPreviouslySubmitted = !!getUserFeedbackSubmittedCookie();
        if (surveyPreviouslySubmitted) {
            /* User has submitted a complete survey within `USER_FEEDBACK_COOKIE_EXPIRATION` days.
               Do not do trigger any feedback behavior for this user. */
            return;
        }
        const surveyPreviouslyDismissed = !!getUserFeedbackDismissedCookie();
        if (surveyPreviouslyDismissed) {
            /*  User has previously dismissed prompt.
                Do not trigger disruptive prompt, but show button in footer so
                they can re-engage if they choose */
            setIsFeedbackButtonInFooterVisible(true);
        }
        else {
            /*  User has not yet interacted with the survey at all.
                Show them the modal prompt after a timed delay */
            setTimeout(() => {
                setIsUserFeedbackVisible(true);
            }, userFeedbackPromptTimeout);
        }
    }, []);
    const handleSurveyDismissed = (surveyComplete) => {
        setUserFeedbackCookie(surveyComplete);
        setIsUserFeedbackVisible(false);
        // If user dismisses survey before completion, show button in footer so they can re-open the modal
        setIsFeedbackButtonInFooterVisible(!surveyComplete);
    };
    const handleGiveFeedbackClick = () => {
        setIsUserFeedbackVisible(true);
        setIsFeedbackButtonInFooterVisible(false);
        (0, withSnowplowTracking_1.trackUserFeedbackActivity)(snowplowConfig_1.SnowplowAction.SurveyReopened);
    };
    const lastSubmittedQuestion = getUserFeedbackLastSubmittedQuestionCookie();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(UserFeedback_1.default, { isMobile: r({ md: false, xs: true }), isModalVisible: isUserFeedbackVisible, lastSubmittedQuestionIndex: lastSubmittedQuestion
                    ? parseInt(lastSubmittedQuestion, 10)
                    : undefined, logQuestionAnswered: setUserAnsweredQuestionCookie, onDismiss: handleSurveyDismissed, surveyLink: surveyMonkeyLink }), (0, jsx_runtime_1.jsx)(ButtonWrapper, { "$opacity": isFeedbackButtonInFooterVisible ? 1 : 0, fullWidth: r({ md: false, xs: true }) || false, children: (0, jsx_runtime_1.jsx)(common_buoy_button_1.BaseButton, { "data-testid": "give-feedback-footer-button", onClick: handleGiveFeedbackClick, showFocusRing: true, startIcon: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.MessageIcon, { size: 20 }), styles: buttonStyles, touchRippleColor: theme.palette.blue[10], children: "Feedback" }) })] }));
};
exports.default = UserFeedbackModal;
//# sourceMappingURL=index.js.map